import { __makeTemplateObject, __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import styled from 'styled-components';
import { Text } from '@primer/react';

var StyledComponent = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen,\n    Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  font-style: normal;\n"], ["\n  color: ", ";\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen,\n    Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  font-style: normal;\n"])), function (props) {
  return props.color;
}, function (props) {
  var _a;
  return (_a = props.style) === null || _a === void 0 ? void 0 : _a.fontSize;
}, function (props) {
  var _a;
  return (_a = props.style) === null || _a === void 0 ? void 0 : _a.fontWeight;
}, function (props) {
  var _a;
  return (_a = props.style) === null || _a === void 0 ? void 0 : _a.lineHeight;
});
var StyledHeaderSemiBold = styled(StyledComponent)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n"], ["\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n"])));
var StyledBodyRegular = styled(StyledComponent)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.15px;\n  font-weight: 400;\n"], ["\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.15px;\n  font-weight: 400;\n"])));
var StyledHeaderBold = styled(StyledBodyRegular)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-weight: 600;\n"], ["\n  font-weight: 600;\n"])));
var StyledTextSmallRegular = styled(StyledComponent)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: 12px;\n  line-height: 18px;\n  font-weight: 400;\n"], ["\n  font-size: 12px;\n  line-height: 18px;\n  font-weight: 400;\n"])));
var StyledTextSmallBold = styled(StyledTextSmallRegular)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-weight: 600;\n"], ["\n  font-weight: 600;\n"])));
var LTText = function LTText(_a) {
  var _b = _a.as,
    as = _b === void 0 ? "span" : _b,
    _c = _a.className,
    className = _c === void 0 ? "" : _c,
    children = _a.children,
    _d = _a.color,
    color = _d === void 0 ? "#333" : _d,
    id = _a.id,
    _e = _a.style,
    style = _e === void 0 ? {} : _e,
    _f = _a.text,
    text = _f === void 0 ? "" : _f,
    variant = _a.variant,
    rest = __rest(_a, ["as", "className", "children", "color", "id", "style", "text", "variant"]);
  var content = children || text;
  switch (variant) {
    case LTText.TextVariant.HEADER_BOLD:
      return /*#__PURE__*/React.createElement(StyledHeaderSemiBold, __assign({
        as: as,
        className: className,
        color: color,
        id: id
      }, rest, {
        style: style
      }), content);
    case LTText.TextVariant.SUBHEADER_REGULAR:
      return /*#__PURE__*/React.createElement(StyledBodyRegular, __assign({
        as: as,
        className: className,
        color: color,
        id: id
      }, rest, {
        style: style
      }), content);
    case LTText.TextVariant.SUBHEADER_BOLD:
      return /*#__PURE__*/React.createElement(StyledHeaderBold, __assign({
        as: as,
        className: className,
        color: color,
        id: id
      }, rest, {
        style: style
      }), content);
    case LTText.TextVariant.SMALL_BOLD:
      return /*#__PURE__*/React.createElement(StyledTextSmallBold, __assign({
        as: as,
        className: className,
        color: color,
        id: id
      }, rest, {
        style: style
      }), content);
    case LTText.TextVariant.SMALL_REGULAR:
      return /*#__PURE__*/React.createElement(StyledTextSmallRegular, __assign({
        as: as,
        className: className,
        color: color,
        id: id
      }, rest, {
        style: style
      }), content);
    default:
      return /*#__PURE__*/React.createElement(StyledComponent, __assign({
        as: as,
        color: color,
        id: id
      }, rest, {
        style: style
      }), content);
  }
};
LTText.TextVariant = {
  HEADER_BOLD: "HEADER_BOLD",
  SUBHEADER_BOLD: "SUBHEADER_BOLD",
  SUBHEADER_REGULAR: "SUBHEADER_REGULAR",
  SMALL_BOLD: "SMALL_BOLD",
  SMALL_REGULAR: "SMALL_REGULAR"
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

export { LTText as default };
